import React from 'react';
import { useHistory } from 'react-router-dom';
// import { isMobile } from 'react-device-detect';

import Mapa from '../components/Mapa';
import VoteForm from '../components/VoteForm';
import Regulamento from '../components/Regulamento';

import { useGlobal } from '../contexts/global';

import '../assets/scss/Vote.scss';

import iconClose from '../assets/images/icon_close.png';

const Vote = () => {
  const { showRegulamento } = useGlobal();
  const history = useHistory();

  return (
    <div className="in-vote">
      <div className="in-vote-close">
        <button
          type="button"
          onClick={() => {
            const savedCityPage = sessionStorage.getItem('cidadeAtivaPage');
            const savedScroll = sessionStorage.getItem('lastScroll');
            history.replace(savedCityPage || '/');
            if (savedScroll) {
              setTimeout(() => {
                window.scrollTo(0, parseInt(savedScroll, 10));
                sessionStorage.removeItem('lastScroll');
              }, 0);
            }
          }}
        >
          <img src={iconClose} alt="Fechar" />
          <span>Fechar</span>
        </button>
      </div>
      <div className="in-vote-grid">
        {showRegulamento && <Regulamento />}
        <VoteForm />
        <Mapa />
      </div>
    </div>
  );
};

export default Vote;
